import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { LoginModel } from '../model/login.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from '../services/localstorage.service';
import { SnackBarService } from '../services/snack-bar-service.service';
import { environment } from 'src/environments/environment';
import { IBuscaMotoristaModel, IConsultaMotoristaModel, IFiltroMotoristaModel } from './model/motorista.model';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class MotoristaService {
  
  public usuario!: LoginModel;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient, 
      private localStorageService: LocalStorageService,
      private snackBar: SnackBarService) { 
    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  
  listMotorista(filtro: IFiltroMotoristaModel): Observable<IConsultaMotoristaModel>{

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaMotorista;

    return this.http.post<IConsultaMotoristaModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar os motoristas.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaMotoristaModel>('Não foi possível consultar os motoristas.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  searchMotorista(filtro: IBuscaMotoristaModel): Observable<IConsultaMotoristaModel>{

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_BuscaMotorista;

    return this.http.post<IConsultaMotoristaModel>(url, filtro, this.httpOptions).pipe(map(response => {
      response.retorno.forEach( (motorista) => {
        motorista.busca = motorista.matricula.toString() + ' - ' + motorista.apelido.trim() + ' - ' + motorista.codProduto?.toString() + ' - ' + motorista.status;
      });
      return response;
    }));
  }

  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.flashMessage(mensagem, ['snackbar-error'], 'Fechar', 0);

      return of(result as T);
    };
  }

}